<template>
  <v-container fill-height fluid grid-list-xl>
    <material-tabs :tabs="tabs">
      <v-flex slot="body" xs12>
        <router-view />
      </v-flex>
    </material-tabs>
  </v-container>
</template>

<script>
import MaterialTabs from '@/components/material/Tabs';

// @vuese
// Wyświetlanie profilu partnera
// @group Partners
export default {
  components: {
    MaterialTabs
  },
  data() {
    return {
      tabs: [
        {
          name: 'Profil',
          route: `/partners/${this.$route.params.id}`,
          icon: 'mdi-folder-account',
          permission: ['PARTNER.GET'],
          entityType: 'partner',
          entityId: this.$route.params.id
        },
        {
          name: 'Usługi',
          route: `/partners/${this.$route.params.id}/benefits`,
          icon: 'mdi-cards-outline',
          permission: ['BENEFIT.LIST'],
          entityType: 'partner',
          entityId: this.$route.params.id
        },
        {
          name: 'Użycie',
          route: `/partners/${this.$route.params.id}/usage`,
          icon: 'mdi-chart-timeline',
          permission: ['BENEFIT_USE.LIST'],
          entityType: 'partner',
          entityId: this.$route.params.id
        },
        {
          name: 'Historia',
          route: `/partners/${this.$route.params.id}/history`,
          icon: 'mdi-history',
          permission: ['HISTORY.LIST'],
          entityType: 'partner',
          entityId: this.$route.params.id
        },
        {
          name: 'Obiekty',
          route: `/partners/${this.$route.params.id}/places`,
          icon: 'mdi-bank',
          permission: ['PLACE.LIST'],
          entityType: 'partner',
          entityId: this.$route.params.id
        }
      ]
    };
  }
};
</script>
